import { useLocations } from '../hooks/useLocations';
import { storageUrl } from '../firebase';

import { SolarButton } from './SolarButton';
import useSolars from '../hooks/useSolars';
import { useState } from 'react';
import { Area, SolarType } from '../CommonTypes';
import {
  apartmentOnTopState,
  currentApartmentAtom,
  currentSlideAtom,
  hooveredApartmentId,
  hoveredApartmentAreaAtom,
  hoveredInfoAreaAtom,
  hoveredViewAreaAtom,
  isMobile,
  showAvailableState,
} from '../states/planner';
import { useAtom } from 'jotai';
import { CustomShapeArea } from './CustomShapeArea';
import { useApartments } from '../hooks/useApartments';
import { SolarOptions } from './SolarOptions';

interface BuildingViewArgs {
  viewid: string;
  picture: string;
  svgurl: string;
  compass:
    | 'N'
    | 'NNW'
    | 'NW'
    | 'WNW'
    | 'W'
    | 'WSW'
    | 'SW'
    | 'SSW'
    | 'S'
    | 'SSE'
    | 'SE'
    | 'ESE'
    | 'E'
    | 'ENE'
    | 'NE'
    | 'NNE';
}

const BuildingView = ({ viewid, picture, compass, svgurl }: BuildingViewArgs) => {
  const usingSVG = svgurl ? true : false;
  // const [svgViewBox, locationsSvg] = useLocations(svgurl, 'mantorpview.svg');
  const [svgViewBox, locationsSvg] = useLocations(svgurl);
  const [solars, defaultIndex] = useSolars(viewid);
  const [selectedSolar, setSelectedSolar] = useState<SolarType | null>(solars[defaultIndex || 0]);
  const currentSolar = selectedSolar ? selectedSolar : solars[defaultIndex || 0];

  const [, setCurrentSlide] = useAtom(currentSlideAtom);

  const changeSlide = (id: string) => {
    setCurrentSlide(Number(id));
  };
  const [, setApartmentOnTop] = useAtom(apartmentOnTopState);
  const [overApartmentId, setOverApartmentId] = useAtom(hooveredApartmentId);
  const [, setCurrentApartment] = useAtom(currentApartmentAtom);
  const [showAvailable] = useAtom(showAvailableState);

  const [, setHoveredViewArea] = useAtom(hoveredViewAreaAtom);
  const [, setHoveredInfoArea] = useAtom(hoveredInfoAreaAtom);
  const [, setHoveredApartmentArea] = useAtom(hoveredApartmentAreaAtom);

  const apartments = useApartments();
  if (!apartments) {
    return <></>;
  }

  const locations = locationsSvg;
  const viewBox = svgViewBox;

  if (!viewBox) return <></>;
  return (
    <div className="relative inline-block">
      <img
        alt="ViewImage"
        src={storageUrl(currentSolar && process.env.NODE_ENV === 'development' ? currentSolar.imageurl : picture)}
        className={compass + ' block h-auto max-w-full'}
      />
      <SolarButton currentSolar={currentSolar} />
      <SolarOptions currentSolar={currentSolar} onChange={setSelectedSolar} />
      <svg className="absolute left-0 top-0" viewBox={viewBox} preserveAspectRatio="none">
        {locations.map((l, idx) => {
          const key = `${l.type}-${idx}`;

          if (l.type === 'apartment') {
            const apartment = apartments.find(a => a.apartmentid === l.ref_id);
            if (!apartment) {
              return null;
            }

            const setHoveredApartmentArea2 = (area: Area | null) => {
              setHoveredApartmentArea(area);
              setApartmentOnTop(apartment);
              setOverApartmentId(apartment.apartmentid);
            };
            const handleMouseLeave = () => {
              setOverApartmentId(null);
            };

            const classes = [
              'location-path',
              apartment.status,
              overApartmentId == apartment.apartmentid ? 'showbold' : '',
              showAvailable ? 'show' : '',
            ].join(' ');

            return (
              <CustomShapeArea
                key={key}
                location={l}
                anchorType="box"
                className={classes}
                setArea={setHoveredApartmentArea2}
                handleMouseLeave={handleMouseLeave}
                onClick={e => {
                  e.preventDefault();

                  if (isMobile()) {
                    setOverApartmentId(null);
                    setTimeout(() => {
                      setApartmentOnTop(apartment);

                      setCurrentApartment(apartment);
                    }, 450);
                  } else {
                    setCurrentApartment(apartment);
                  }
                }}
              />
            );
          } else if (l.type === 'view') {
            const classes = ['view-path', showAvailable ? 'show' : ''].join(' ');

            return (
              <CustomShapeArea
                key={key}
                location={l}
                className={classes}
                setArea={setHoveredViewArea}
                onClick={e => {
                  e.preventDefault();
                  setHoveredViewArea(null);
                  if (isMobile()) {
                    setTimeout(() => {
                      changeSlide(l.ref_id);
                    }, 350);
                  } else {
                    changeSlide(l.ref_id);
                  }
                }}
              />
            );
          } else if (l.type === 'viewinfo') {
            const classes = ['info-path'].join(' ');
            return (
              <CustomShapeArea
                key={key}
                location={l}
                className={classes}
                setArea={setHoveredInfoArea}
                openOnClick={true}
              />
            );
          } else if (l.type === 'info') {
            const classes = ['infogroup', 'w-[100px]'].join(' ');

            const info = usingSVG ? locations.find(i => i.id === l.ref_id) : undefined;
            if (!info) return null;

            const pathStyle = { fill: info.color, opacity: '0.7' };
            return (
              <CustomShapeArea
                key={key}
                location={l}
                className={classes}
                pathStyle={pathStyle}
                setArea={setHoveredInfoArea}
                openOnClick={true}
                mobileScale={1.5}
              >
                <path style={{ fill: '#FFF' }} className="innerfigure" d={info.coordinates} />
              </CustomShapeArea>
            );
          }

          return null;
        })}
      </svg>
    </div>
  );
};

export default BuildingView;
